module.exports = __webpack_public_path__ + "static/media/slider02_sc.65c1ad6b.png";